export default "__VITE_ASSET__Dwxw69IN__"